import { findObjectsWithValidId } from './utils'

export type GetRids = typeof getRids

/**
 * Находит в переданных данных все ID объектов и возвращает соответствующие объекты из R.items.
 * Если указана таблица, фильтрует только объекты с этой таблицей.
 * @param data - объект данных для поиска
 * @param table - название таблицы (опционально)
 * @returns массив id без дубликатов и готовых к вставке в запросы Surreal
 */
export const getRids = (data: any, table?: string): string[] => {
	if (!data) {
		return []
	}

	// Находим объекты с валидными ID
	const rawItems = findObjectsWithValidId(data)

	// Фильтруем только те, у которых таблица совпадает с искомой (если таблица указана)
	const filteredIds = table
		? rawItems.filter((item) => item.id && item.id.tb === table).map((item) => item.id.toString())
		: rawItems.map((item) => item.id.toString())

	// Удаляем дубликаты id
	const uniqueIds = [...new Set(filteredIds)]

	return uniqueIds
}
